import { useState, useEffect, useContext } from "react";
import { Authorization } from "../../../Context/Authorization";
import axios from "axios";
import { AuthContext } from "../../../Context/AuthContext";
import { Col, Row, Form, Table } from "react-bootstrap";
import "../Vfc.css";

const RenewalFormat = () => {
  const Api = process.env.REACT_APP_API;
  const { userId } = useContext(AuthContext);

  const [range, setRange] = useState([]);
  const [vfcData, setVfcData] = useState([]);
  const [selectedRange, setSelectedRange] = useState("");
  const [selectedVfc, setSelectedVfc] = useState("");
  const [vfcDetails, setVfcDetails] = useState(null);
  const [members, setMembers] = useState([]);

  useEffect(() => {
    const fetchRange = async () => {
      try {
        const config = Authorization();
        const response = await axios.get(`${Api}/api/ranges`, config);
        setRange(response.data);
      } catch (err) {
        console.error("Error fetching ranges", err);
      }
    };
    fetchRange();
  }, []);

  const handleRangeChange = async (e) => {
    const rangeId = e.target.value;
    setSelectedRange(rangeId);
    setSelectedVfc("");
    try {
      const config = Authorization();
      const response = await axios.post(
        `${Api}/api/vfcs/vfcs-by-range`,
        { rangeId },
        config
      );
      setVfcData(response.data.vfcs);
    } catch (err) {
      console.error("Error fetching VFCs by range", err);
    }
  };

  const handleVfcChange = async (e) => {
    const vfcId = e.target.value;
    setSelectedVfc(vfcId);
    try {
      const config = Authorization();
      const [vfcRes, designationRes] = await Promise.all([
        axios.get(`${Api}/api/vfcs/${vfcId}`, config),
        axios.post(
          `${Api}/api/member/designation/all-designations`,
          { vfcId },
          config
        ),
      ]);
      setVfcDetails(vfcRes.data.vfc);
      setMembers(designationRes.data || []); // You get designations directly here
      console.log(vfcRes.data.vfc);
      console.log(designationRes.data);
    } catch (err) {
      console.error("Error fetching VFC/member info", err);
    }
  };

  const currentYear = new Date().getFullYear();
  const financialYear = `${currentYear}-${currentYear + 1}`;

  const handlePrint = () => {
    const printContent = document.getElementById("content-to-print");
    const originalContent = document.body.innerHTML;

    // Temporarily hide everything else and display only the content you want to print
    document.body.innerHTML = printContent.outerHTML;

    // Trigger print dialog
    window.print();

    // After printing, restore the original content
    document.body.innerHTML = originalContent;
  };

  return (
    <div className="col-md-12 grid-margin stretch-card">
      <div className="card">
        <div className="card-body">
          <p className="card-description">வனக்குழு புதுப்பிப்பு படிவம்</p>

          <Row>
            <Col xs={6}>
              <Form.Group controlId="Range">
                <Form.Label>Range</Form.Label>
                <Form.Control
                  as="select"
                  value={selectedRange}
                  onChange={handleRangeChange}
                >
                  <option value="">Select Range</option>
                  {range.map((r) => (
                    <option key={r._id} value={r._id}>
                      {r.rangeName}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col xs={6}>
              <Form.Group controlId="VFC">
                <Form.Label>VFC Name</Form.Label>
                <Form.Control
                  as="select"
                  value={selectedVfc}
                  onChange={handleVfcChange}
                >
                  <option value="">Select VFC</option>
                  {vfcData.map((vfc) => (
                    <option key={vfc._id} value={vfc._id}>
                      {vfc.vfcName}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>

          {/* Printable Area */}
          <div id="content-to-print">
            {vfcDetails && (
              <>
                {/* Page 1: Request Letter */}
                <div className="print-section portrait mt-4 p-3 border">
                  <span className="bamini-text">
                    <strong>mDg;Gdu;</strong>
                  </span>
                  <p className="ml-5 bamini-text">nrayhsu;</p>
                  <p className="ml-5">
                    Village Forest Council, {vfcDetails.vfcName}
                  </p>
                  <p className="ml-5">{vfcDetails.village}</p>
                  <p className="ml-5">{vfcDetails.address}</p>
                  <p className="ml-5">{vfcDetails.panchayath}</p>
                  <p className="ml-5">{vfcDetails.thaluk}</p>
                  <p className="ml-5">{vfcDetails.pinCode}</p>

                  <span className="bamini-text">
                    <strong>ngWeu;</strong>
                  </span>
                  <p className="ml-5 bamini-text">
                    cau;jpU khtl;l gjpthsu; mtu;fs;
                  </p>
                  <p className="ml-5 bamini-text">khtl;l gjpthsu; mYtyfk;</p>

                  <br />
                  <span className="bamini-text">mk;kh</span>
                  <br />
                  <p>
                    <span className="bamini-text ml-4">nghUs;</span>:
                    <span className="bamini-text">
                      <strong>gjpT vz;</strong>
                    </span>
                    : {vfcDetails.registrationNo} - Village Forest Council,
                    {vfcDetails.vfcName} {financialYear}
                    <span className="bamini-text">
                      -k; Mz;bw;fhd tuT nryT fzf;F Mbl;lu; mwpf;if kw;Wk;
                      tUlhe;jpu mwpf;iffs; fPo;fz;lthW jq;fs; mYtyfj;jpy;
                      gjpTf;F jhf;fy; nra;fpNwhk;.Nfhu;it nra;jpLkhW kpfTk;
                      jho;ikAld; Ntz;LfpNwhk;. ,jw;Fupa fl;lzk; ,j;Jld;
                      nrYj;JfpNwhk;
                    </span>
                  </p>
                  <span className="bamini-text">,izg;G</span>
                  <ol>
                    <li className="bamini-text">cWjpnkhop</li>
                    <li className="bamini-text">gbtk;</li>
                    <li className="bamini-text">
                      {financialYear} -k; Mz;bd; tuT nryT Mbl;lu; mwpf;if
                    </li>
                    <li className="bamini-text">nghJf;FO jPu;khd efy;</li>
                  </ol>
                </div>
                <div className="page-break"></div>
                {/* Page 2: Table */}
                <div className="print-section mt-4 border p-3">
                  <h4 className="text-center">FORM-VI: EC Member List</h4>
                  <Table bordered>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Designation</th>
                      </tr>
                    </thead>
                    <tbody>
                      {members.map((m, i) => (
                        <tr key={m._id}>
                          <td>{i + 1}</td>
                          <td>{m.name}</td>
                          <td>{m.designation}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
                <div className="page-break"></div>
                {/* Page 3: Signature */}
                <div className="print-section portrait mt-5 border p-3">
                  <p className="ml-5 text-center">
                    Village Forest Council, {vfcDetails.vfcName}
                  </p>
                  <p className="text-center">{vfcDetails.village}</p>
                  <p className="text-center">{vfcDetails.address}</p>
                  <p className="text-center">{vfcDetails.panchayath}</p>
                  <p className="text-center">{vfcDetails.thaluk}</p>
                  <p className="text-center">{vfcDetails.pinCode}</p>
                  <p className="text-center">{vfcDetails.registrationNo}</p>
                  <h4 className="text-center bamini-text">
                    <strong>cWjpnkhop</strong>
                  </h4>
                  <p>
                    Village Forest Council, {vfcDetails.vfcName}
                    <span className="bamini-text">
                      vd;w vq;fsJ rq;fk; fle;j 2024-2025-k; Mz;by; ey;yKiwapy;
                      nray;gl;L te;Js;sJ vd;Wk; mNjNghy; elg;G Mz;bYk; vq;fsJ
                      rq;fk; ey;y Kiwapy; ,aq;fp tUfpwJ vd;Wk; ,jd; %yk; cWjp
                      $WfpNwd;
                    </span>
                  </p>
                </div>
              </>
            )}
          </div>

          {/* Actions */}
          <div className="mt-3">
            <button
              className="btn btn-primary me-2 no-print"
              onClick={handlePrint}
            >
              Print
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RenewalFormat;
